export const COMMON_VERSION = `Solaris Lens™ Common Lib ${new Date().getFullYear()} v.1.28.5`;
export const APP_PATHS = {
  admin: {
    name: 'Admin',
    path: '/admin'
  },
  fleetStatusDashboard: {
    name: 'FleetStatusDashboard',
    path: '/fleetstatus'
  }
};
export const ADMIN_ACCESS_LEVEL = {
  groups: ['FieldAdmin']
};
export const USER_PAGE_SIZE = 20;

export const GROUP_SYSTEM_ADMINISTRATORS = 'SystemAdministrators';
export const GROUP_FIELD_ADMIN = 'FieldAdmin';

export const APP_NAME_VISION_WEB = 'Solaris Vision Web';
export const APP_NAME_VISION_MOBILE = 'Solaris Vision Mobile';

export const APP_NAME_LENS_WEB = 'Solaris Lens Web';
export const APP_NAME_LENS_MOBILE = 'Solaris Lens Mobile';

export const APP_NAME_OPTICS_WEB = 'Solaris Optics Web';
export const APP_NAME_OPTICS_MOBILE = 'Solaris Optics Mobile';

export const APP_NAME_DRIVER_MOBILE = 'Solaris Driver Mobile';

export const APP_NAME_PULSE_MOBILE = 'Solaris Pulse Mobile';
export const APP_NAME_PULSE_WEB = 'Solaris Pulse Web';

export const APP_NAME_POWER_SOLUTIONS_WEB = 'Solaris Power Solutions Web';

export const LBS_IN_ONE_TON = 2000;
